import React from 'react';
import { DialogActions, Button, CircularProgress } from '@mui/material';

const VideoUploadActions = ({ handleClose, isLoading, videoSaveHandler }) => (
  <DialogActions
    className={`fullWidth flexBox flexWrap dialogActionsFixed`}
    sx={{
      alignItems: 'center',
      justifyContent: 'center',
      paddingRight: '10%',
      paddingLeft: '10%',
      gap: 1,
      mt: 3,
    }}
  >
    <Button
      variant='outlined'
      onClick={handleClose}
      sx={{
        width: '48%',
        fontFamily: 'Lato',
        textTransform: 'capitalize',
        color: 'var(--clr-theme-purple)',
        borderColor: 'var(--clr-theme-purple)',
      }}
      disabled={isLoading}
    >
      Cancel
    </Button>
    <Button
      sx={{
        alignItems: 'center',
        backgroundColor: 'var(--clr-theme-purple)!important',
        color: 'white',
        width: '48%',
        fontFamily: 'Lato',
        textTransform: 'capitalize',
        '&:disabled': {
          color: 'var(--clr-theme-white) !important',
          backgroundColor: 'rgb(211, 211, 211) !important',
        },
      }}
      variant='contained'
      onClick={videoSaveHandler}
      disabled={isLoading}
      startIcon={isLoading ? <CircularProgress size={16} sx={{ color: 'white' }} /> : null}
    >
      {isLoading ? 'Saving...' : 'Save'}
    </Button>
  </DialogActions>
);

export default VideoUploadActions;
